import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';
import { agGridLicense } from './assets/ag-grid/ag-grid-ent';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

document.documentElement.setAttribute('data-platform', navigator.platform);
LicenseManager.setLicenseKey(agGridLicense.applyLicense());
